export const platformFormat = (platform: string) => {
  if (platform === 'app') {
    return '[APP] ';
  } else if (platform === 'web') {
    return '[WEB] ';
  }
};
